class BarChart {
  constructor({
    id = null,
    title = '',
    description = '',
    apiName = '',
    layout = null,
    queryParams = {},
    createdAt = null,
    updatedAt = null,
    uid = null,
  } = {}) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.apiName = apiName;
    this.layout = layout;
    this.queryParams = queryParams;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.uid = uid;
  }

  setData(data) {
    this.id = data.id;
    this.title = data.title;
    this.description = data.description;
    this.apiName = data.apiName;
    this.layout = data.layout;
    this.queryParams = data.queryParams || {};
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.uid = data.uid;
  }

  toUpdate() {
    return {
      title: this.title,
      description: this.description,
      apiName: this.apiName,
      layout: this.layout,
      queryParams: this.queryParams,
    };
  }
}

export default BarChart;
